<div class="page-row-card" (click)="onClick()">
  <div class="{{isNarrow ? 'card-image-container-narrow' : 'card-image-container'}}">
    <img src="{{dto.imageUrl}}" alt="logo"/>
    <div class="card-price-tag">{{ dto.price }} CHF</div>
  </div>
  <div class="card-content">
    <div class="card-headline secondary {{isNarrow||isSmall ? 'small-header' : ''}}">{{ dto.title }}</div>
    <div class="card-description {{isNarrow||isSmall ? 'small-content' : ''}}">{{ formatDescription(dto.description) }}</div>
    <div class="card-details">{{
        'courses.infoline.' + (dto.futureAppointments === 1 ? 'one' : 'other') |
          transloco: {
          count: dto.futureAppointments, start: (dto.start | date:'dd.MM.yyyy'), end: (dto.end |
            date:'dd.MM.yyyy')
        }
      }}
    </div>
    @if(dto.hideTherapist != true){
    <div class="card-details">{{getInfoLine()}}</div>
    }
  </div>
</div>
